import React, {memo, useEffect, useState, ReactNode} from 'react';
import {Image, ImageProps} from 'react-native';

interface FallbackImageProps extends Omit<ImageProps, 'source'> {
  uri?: string;
  fallback: ReactNode;
  timeout?: number;
}

const FallbackImage: React.FC<FallbackImageProps> = memo(
  ({uri, fallback, timeout = 5000, ...rest}) => {
    const [useFallback, setUseFallback] = useState(!uri);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
      if (!uri) return;

      const timer = setTimeout(() => {
        if (!loaded) setUseFallback(true);
      }, timeout);

      return () => clearTimeout(timer);
    }, [uri, loaded, timeout]);

    if (useFallback) {
      return <>{fallback}</>;
    }

    return (
      <Image
        source={{uri}}
        onLoad={() => setLoaded(true)}
        onError={() => setUseFallback(true)}
        {...rest}
      />
    );
  },
);

export default FallbackImage;
